import { useClickOutside } from "hook/useClickOutside";
import React, { useRef, useState } from "react";
import EmailsList from "./EmailsList";
import EmailsOptions from "./EmailsOptions";
import SavedEmails from "./SavedEmails";
import { getRandColor } from "./emailRandomColor";
import "./index.scss";

const Emails = ({ savedEmails, setSavedEmails, disableAddingToEmails = false, defaultToEmailText = "" }) => {
  const emailsRef = useRef(null);
console.log('defaultToEmailText', defaultToEmailText)
  const [enabledOptions, setEnabledOptions] = useState(["to"]);
  useClickOutside(emailsRef, () => {
    setEnabledOptions((prev) => prev.filter((item) => item !== "to"));
  });

  const addEmailsHandler = ({ type, email }) => {
    if (savedEmails.some((savedEmail) => savedEmail.email === email)) return;
    setSavedEmails((prev) => [
      ...prev,
      {
        type,
        email,
        image: email.charAt(0).toUpperCase(),
        color: getRandColor(),
      },
    ]);
  };

  const removeEmailHandler = (email) => {
    setSavedEmails((prev) => prev.filter((item) => item.email !== email));
  };

  const toggleEmails = (option) => {
    if (enabledOptions.includes(option)) {
      setEnabledOptions(enabledOptions.map((item) => item !== option));
    } else {
      setEnabledOptions([...enabledOptions, option]);
    }
  };

  const options = [
    {
      id: "cc",
      label: "Cc",
      action: () => toggleEmails("cc"),
      enabled: !enabledOptions.includes("cc"),
    },
    {
      id: "bcc",
      label: "Bcc",
      action: () => toggleEmails("bcc"),
      enabled: !enabledOptions.includes("bcc"),
    },
  ];

  const checkEnableEmails = (option) => {
    return enabledOptions.includes(option);
  };

  const filterEmails = (type) => {
    return savedEmails.filter((item) => item.type === type);
  };

  const checkEnableOptions = () => {
    return !enabledOptions.includes("cc") || !enabledOptions.includes("bcc");
  };

  const emailsTypes = [
    {
      type: "to",
      label: "To:",
      list: filterEmails("to"),
      addEmailsHandler,
      removeEmail: removeEmailHandler,
      enabled: enabledOptions.includes("to") || !savedEmails.length || defaultToEmailText,
      disabledAdding: disableAddingToEmails,
      defaultEmailText: defaultToEmailText,
    },
    {
      type: "cc",
      label: "Cc:",
      list: filterEmails("cc"),
      addEmailsHandler,
      removeEmail: removeEmailHandler,
      enabled: checkEnableEmails("cc"),
    },
    {
      type: "bcc",
      label: "Bcc:",
      list: filterEmails("bcc"),
      addEmailsHandler,
      removeEmail: removeEmailHandler,
      enabled: checkEnableEmails("bcc"),
    },
  ];


  return (
    <div className="emails" ref={emailsRef}>
      {!enabledOptions.includes("to") && savedEmails.length && !defaultToEmailText ? (
        <SavedEmails emails={savedEmails} toggleEmails={toggleEmails} />
      ) : (
        emailsTypes.map(
          (email) => email.enabled && <EmailsList key={email.type} {...email} />
        )
      )}
      {checkEnableOptions() && <EmailsOptions options={options} />}
    </div>
  );
};

export default Emails;
